

<div class="dialog">
    <div class="dialog-title">
        <h4 class="semi-bold">Submit Painting <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h4>
    </div>
    <div class="content">
        <div class="row  container-fluid mr-0 ml-0 shipment">
     
        </div>
        <div class="file-drop primary-file-upload mt-3 mb-2" *ngIf="uploaded_file_name === '' ">
            <form [formGroup]="demoForm">
              

                <file-upload formControlName="files" accept=".pdf,.xls,.jpeg,.png">
                    <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                        <file-upload-drop-zone>
                            <ng-container *ngIf="isFileDragDropAvailable; else isNotDragDropAvailable">
                                <b>Upload Painting File</b><br> (Max Size up to 10MB)
                            </ng-container>
                            <ng-template #isNotDragDropAvailable>
                                <b>Click here to upload</b>
                            </ng-template>
                        </file-upload-drop-zone>
                    </ng-template>
            
                    <ng-template let-i="index" let-file="file" let-control="control" #item>
                        <file-upload-list-item  [index]="i" [file]="file" [control]="control">Remove</file-upload-list-item>
                    </ng-template>
                </file-upload>
            </form>
        </div>
        <div class="file-drop primary-file-upload mt-3 mb-2" *ngIf="uploaded_file_name !== '' ">
            <mat-chip class="square-chip" [disabled]="data.bDisabled">
            <span (click)="downloadUrl()">{{uploaded_file_name}}</span>
            <mat-icon class="mat-chip-remove mat-chip-trailing-icon" (click)="removeFile()">clear</mat-icon>
          </mat-chip>
        </div>
    </div>
    <div class="container-fluid mt-4 mb-3 mr-0 ml-0">
      
        <mat-checkbox [checked]="is_Paintingchecked" [(ngModel)]="is_Paintingchecked"
        (change)="onchangePaintingValue($event)" class="mb-3" color="warn">
        <span class="checkbox-label">Is Painiting Done?.</span>
    </mat-checkbox><br>


  
    </div>
    <div class="button text-center">
        <button class="white mr-2" (click)="close()">Cancel</button>
        <button class="orange ml-2" (click)="submit()">Submit</button>
    </div>
</div>
